import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { decodeId } from "../../utills/idUtils";
import FancyLoader from "../../hooks/FancyLoder";
import {
  getAsmtById,
  getComponentWiseAvgScore,
} from "../../services/authService";

const API_URL = process.env.REACT_APP_API_URL;

const OverAllSummary = ({ isGeneratingPdf, assessment_type }) => {
  const { encodedId } = useParams();
  const id = decodeId(encodedId);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [averageScore, setAverageScore] = useState(0);
  const [scoreCategory, setScoreCategory] = useState("");
  const [asmtType, setAsmtType] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // console.log("response==>", response)
        const asmtData = await getAsmtById(id);
        console.log("asmtData.assessment_type", asmtData.assessment_type);
        setAsmtType(asmtData.assessment_type);
        const is360 = asmtData.assessment_type === "360";
        const response = await getComponentWiseAvgScore(id); // Fetch component-wise average scores
        const scores = is360
          ? response.data.filter(
            (score) => score.association_type === "participant"
          )
          : response.data;

        // Process scores
        const processedScores = scores.map((score) => ({
          ...score,
          avgScore: parseFloat(score["sum(aua.answer_value)"]),
        }));
        // console.log("overall astmt score,", processedScores)

        const totalScore = processedScores.reduce(
          (sum, score) => sum + (score.avgScore || 0),
          0
        );

        const avgScore = totalScore;
        // console.log("avgScore", avgScore)
        // Determine score category
        // console.log("object")
        // if (avgScore >= 80) {
        //     setScoreCategory('Excellent');
        // } else if (avgScore >= 48) {
        //     setScoreCategory('Average');
        // } else {
        //     setScoreCategory('Below Average');
        // }
        if (avgScore >= 70) {
          setScoreCategory("Excellent");
        } else if (avgScore >= 41) {
          setScoreCategory("Average");
        } else {
          setScoreCategory("Below Average");
        }
      } catch (err) {
        // Handle error
        console.error(err.response ? err.response.data.message : err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return (
      <div>
        <FancyLoader />
      </div>
    );
  }

  return (
    <>

      {/* {assessment_type === "self" && ( */}
      <div style={{ pageBreakBefore: "always", breakBefore: "page" }}></div>
      {/* )} */}

      <div className="px-4 mt-8 lg:px-16">
        <div
          className="flex flex-wrap bg-[#F0F0F0] rounded-lg"
          style={{ background: "rgb(230 230 230  / var(--tw-bg-opacity, 1))" }}
        >
          <div className=" py-4 rounded-tr-md rounded-tl-md  mx-auto text-center">
            <div
              className="bg-blue-600 p-2 text-left  text-white text-lg font-bold "
              style={{ paddingBottom: "5px", fontFamily: "Helvetica" }}
            >
              Overall Assessment Summary
            </div>
            <div
              className="bg-blue-300 text-left text-black text-lg font-bold p-2"
              style={{ paddingBottom: "5px", fontFamily: "Helvetica" }}
            >
              {asmtType === "self"
                ? "This section offers a comprehensive view of your overall evaluation, based on the scores you provided, summarizing your self-assessment of executive presence."
                : "This is a comprehensive view of the overall evaluation based on the average scores from all respondents, summarizing the collective feedback on the executive presence assessment."}
            </div>

            {scoreCategory === "Excellent" && (
              <div
                className={`m-8 text-black p-4 rounded-lg bg-gray-300`}
              >
                <div className="font-bold ">
                  Your Executive Presence Score is Excellent
                </div>
                <p>
                  Your executive presence is rated as Excellent. This score
                  indicates that you consistently demonstrate outstanding
                  leadership qualities, exceptional communication skills, and a
                  strong impact in your role. Your performance is marked by
                  effective presence and influence, setting a high standard of
                  excellence.
                </p>
              </div>
            )}
            {scoreCategory === "Average" && (
              <div
                className={`m-8 text-black p-4 rounded-lg bg-gray-300`}
              >
                <div className="font-bold">
                  Your Executive Presence Score is Average
                </div>
                <p>
                  You can benefit from developing your executive presence further.
                  Analyze your scores & identify areas that you are already good
                  at & others which are more challenging for you. Develop the good
                  ones, to become a source of strength for you & focus on the
                  development areas and develop rituals/practices to inculcate the
                  “right” behaviours, consciously. Practice these behaviours, till
                  they become ingrained.
                </p>
              </div>
            )}
            {scoreCategory === "Below Average" && (
              <div
                className={`m-8 text-black p-4 rounded-lg bg-gray-300`}
              >
                <div className="font-bold">
                  Your Executive Presence Score is Below Average
                </div>
                <p>
                  Executive Presence is an area of development for you. In case,
                  you don’t focus on developing this competence further, it may
                  hamper your leadership impact and curtail your ability to
                  influence your ecosystem. Identify a couple of elements to work
                  with & start practicing the required behaviours. You may benefit
                  from finding & taking support from a coach, to work on your
                  Executive Presence.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OverAllSummary;
